import React from 'react';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { useNavigate } from 'react-router-dom';
import BaseTable from 'components/tables/BaseTable';
import {useListCompaniesQuery} from "apis/companiesApi";
import { FilterMatchMode } from 'primereact/api';

const CompaniesTable = () => {
    const navigate = useNavigate();
    const {data: companies, isFetching} = useListCompaniesQuery()
    const newCompany = () => {
        edit("new");
    }
    const edit = (id) => {
        navigate(`/super-admin/companies/edit/${id}`);
    }

    const actionTemplate = (rowData) => {
        return (
            <Button type="button" icon="pi pi-pencil" onClick={() => edit(rowData.id)} />
        );
    }

    return (
        <BaseTable
            isLoading={isFetching}
            createNew={newCompany}
            emptyMessage="No companies found."
            globalFilterFields={['name']}
            fieldFilters={{
                'global': { value: null, matchMode: FilterMatchMode.CONTAINS },
                'name': { value: null, matchMode: FilterMatchMode.STARTS_WITH }
            }}
            dataList={companies}>
            <Column field="name" header="Name" filter filterPlaceholder="Search by name" />
            <Column className="action-column" headerClassName="centered-header" bodyClassName="p-text-center" header="Actions" body={actionTemplate}></Column>
        </BaseTable>
    )
}

export default CompaniesTable;